import styled from '@emotion/styled'
import SimpleBar from 'simplebar-react'

import { Asable } from '../../types/asable'

type NavListWrapperProps = Asable

export const NavListWrapper = styled(SimpleBar)<NavListWrapperProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 100%;
  overflow: auto;
  list-style-type: none; /* important when using SimpleBar */
`
